import { getClientEnv, isEu } from 'common/util'

// 定义环境变量名称
const MEGA_POSSPORT_API_ENDPOINT = 'NEXT_PUBLIC_MEGA_POSSPORT_API_ENDPOINT'
const MEGA_SHOPPING_API_ENDPOINT = 'NEXT_PUBLIC_MEGA_SHOPPING_API_ENDPOINT'
const MEGA_EVENT_API_ENDPOINT = 'NEXT_PUBLIC_MEGA_EVENT_API_ENDPOINT'
const MEGA_LOGGING_API_ENDPOINT = 'NEXT_PUBLIC_MEGA_LOGGING_API_ENDPOINT'
const MEGA_HOUSE_API_ENDPOINT = 'NEXT_PUBLIC_MEGA_HOUSE_API_ENDPOINT'

// megaApp host
export async function megaAppHost(name: string) {
  const apiEndpointMap: Record<string, string> = {
    passport: MEGA_POSSPORT_API_ENDPOINT,
    shopping: MEGA_SHOPPING_API_ENDPOINT,
    event: MEGA_EVENT_API_ENDPOINT,
    logging: MEGA_LOGGING_API_ENDPOINT,
    house: MEGA_HOUSE_API_ENDPOINT,
  }
  // 优先使用环境变量
  const envEndpoint = getClientEnv(apiEndpointMap[name])
  if (envEndpoint) {
    return envEndpoint
  }

  // 根据不同环境返回不同的host
  const regionIsEu = await isEu();

  const isPr = getClientEnv('REACT_APP_DEPLOY_ENV') === 'pr'

  if (isPr && regionIsEu) {
    return `https://app-${name}-eu-pr.eufy.com`
  }

  if (!isPr) {
    // 目前只有shopping服务存在多环境
    // const subDomain =
    //   (envHost?.includes('dev') || envHost?.includes('test')) && name === 'shopping' ? 'eufylife' : 'eufysecurity'
    // const subDomain = name === 'shopping' ? 'eufysecurity' : 'eufysecurity'
    const subDomain = 'eufysecurity'
    // tutorial 中区美区保持现有逻辑 调用us环境
    return regionIsEu ? `https://app-${name}-eu-qa.${subDomain}.com` : `https://app-${name}-us-qa.${subDomain}.com`
  }

  return `https://app-${name}-us-pr.eufy.com`
}
